<template>
  <div>
    <DashboardHeader title="Manage Database">
      <v-layout row wrap>
        <SnackBar :text="snackBarText" :model="snackBarModel"></SnackBar>
        <v-flex xs12 md3 class="mx-2">
          <SelectTable
            @table-selected="getSelectedTable"
            v-if="isAdmin"
          ></SelectTable>

          <SelectColumns
            v-if="selectedTable"
            :selTable="selectedTable"
            @columns-selected="getSelectedTableColumns"
          ></SelectColumns> </v-flex
        ><v-flex xs12 md8>
          <v-card class="mt-6">
            <v-card-title
              >{{ selectedTable ? formatTableName(selectedTable) : "" }}
              <v-switch
                v-if="selectedTable"
                v-model="selectedTableItemsAll"
                label="Select All"
                class="ml-10 mr-4"
                @change="selectAllTableItems()"
              ></v-switch>

              <v-btn
                v-if="selectedTable"
                class="mx-4"
                rounded
                x-small
                :style="getThemeStyle"
                @click="enterData()"
                ><v-icon>mdi-plus</v-icon></v-btn
              >

              <v-btn
                v-if="selectedTable"
                class="mx-4"
                rounded
                x-small
                color="red"
                dark
                @click="bulkDelete()"
                ><v-icon>mdi-delete</v-icon></v-btn
              ></v-card-title
            >
            <DataTable
              :selectedTable="selectedTable"
              :tableHeader="tableHeader"
              :tableRows="tableRows"
              :selectedTableItemsArray="selectedTableItems"
              @table-item-selected="getSelectedTableItems"
              @edit-item="editTableItem"
            ></DataTable>
          </v-card> </v-flex
      ></v-layout>

      <v-dialog v-model="dialogItem" min-width="900">
        <DatabaseEntryForm
          :selTable="selectedTable"
          :tblHeaders="formLabelHeaders"
          :entryEditData="entryEditData"
          :dropdownItems="dropdownItems"
          :saveFormDataPackage="saveFormDataPackage"
          :status="status"
          @close-dialog="closeDialogItem()"
          @data-saved="dataSaved()"
          @data-updated="dataUpdated()"
        />
      </v-dialog>
      <getGlobalConfirmDelete
        :item="
          selectedTable
            ? 'SELECTED ' + formatTableName(selectedTable)
            : 'SELECTED ITEM'
        "
        @delete-confirmed="takeActionAfterDeleteConfirmChoice"
      ></getGlobalConfirmDelete>
    </DashboardHeader>
  </div>
</template>

<script>
import axios from "@/plugins/axios";
import DashboardHeader from "@/components/DashboardHeader.vue";
import DataTable from "@/components/CrudDatabases/DataTable.vue";
import SelectTable from "@/components/CrudDatabases/SelectTable.vue";
import SelectColumns from "@/components/CrudDatabases/SelectColumns.vue";
import DatabaseEntryForm from "@/components/CrudDatabases/DatabaseEntryForm.vue";
import SnackBar from "@/components/myLibrary/SnackBar.vue";
import getGlobalConfirmDelete from "@/components/myLibrary/GlobalConfirmDeleteDialog.vue";

export default {
  components: {
    DashboardHeader,
    SelectTable,
    SelectColumns,
    DataTable,
    DatabaseEntryForm,
    SnackBar,
    getGlobalConfirmDelete,
  },
  computed: {
    getThemeStyle() {
      return this.$store.getters.getThemeStyle;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getUserSchool() {
      return this.$store.getters.getUserSchool;
    },
  },

  data: () => ({
    selectedTable: null,
    tableHeader: [],
    queryFilter: "1=1",
    tableColumns: [],
    selectedColumns: [],
    tableRows: [],
    dialogItem: false,
    entryEditData: {},
    dropdownItems: [],
    status: null,
    saveFormDataPackage: [],
    formLabelHeaders: [],
    snackBarModel: false,
    snackBarText: null,
    selectedTableItems: [],
    selectedTableItemsAll: false,
  }),
  methods: {
    formatTableName(tableName) {
      let table = "";
      if (tableName && tableName.includes("_")) {
        table = tableName.replace("_", " ");
      } else {
        table = tableName;
      }

      table = table.split(" ");
      if (table.length > 1) {
        let parts = "";
        table.forEach((tab) => {
          parts += tab.toUpperCase() + " ";
        });
        table = parts;
      } else {
        table = table[0].toUpperCase();
      }
      return table;
    },
    getSelectedTable(selectedTable) {
      this.selectedTable = selectedTable;
      this.tableColumns = [];

      this.$store.commit("setLoader", true);

      axios
        .postDataWithToken(
          "/auth/get-columns",
          { table: this.selectedTable },
          this.getAccessToken
        )
        .then((tableColumns) => {
          //filter and remove id, emis and related stuff out
          const filteredColumns = tableColumns.filter((column) => {
            return (
              column != "id" && column != "emis" && !column.includes("_at")
            );
          });

          filteredColumns.forEach((column) => {
            this.tableColumns.push({
              text: this.formatTableName(column),
              value: column,
            });
          });

          this.$store.commit("setLoader", false);
        });
    },
    getSelectedTableColumns(selectedColumns) {
      this.selectedColumns = selectedColumns;
      this.getSelectedTableRows();
    },
    getSelectedTableRows() {
      this.tableHeader = [];

      this.$store.commit("setLoader", true);
      this.tableHeader = [{ value: "selection" }];

      this.selectedColumns.forEach((column) => {
        this.tableHeader.push({
          text: this.formatTableName(column),
          value: column,
        });
      });

      this.tableHeader.push({ text: "Actions", value: "id" });

      axios
        .postDataWithToken(
          "/auth/get-table-rows",
          { table: this.selectedTable, queryFilter: this.queryFilter },
          this.getAccessToken
        )
        .then((tableRows) => {
          this.tableRows = tableRows;
          this.queryFilter = "1=1";
          //this.generateReport();
          this.$store.commit("setLoader", false);
        });
    },
    enterData() {
      this.formLabelHeaders = [];
      //this.getDropdownItemsForm(this.selTable);
      this.tableColumns.forEach((column) => {
        if (column.value != "selection" && column.value != "id") {
          this.formLabelHeaders.push(column.value);
        }
      });
      this.entryEditData = {};
      this.dialogItem = true;
      this.status = "new";
    },
    editTableItem(item) {
      this.formLabelHeaders = [];
      //this.tblHeaders = this.getTableDialogCols(this.selTable);
      //this.getDropdownItemsForm(this.selTable);
      this.tableColumns.forEach((column) => {
        if (column.value != "selection" && column.value != "id") {
          this.formLabelHeaders.push(column.value);
        }
      });
      this.entryEditData = item;
      this.dialogItem = true;
      this.status = "edit";
    },
    dataSaved() {
      this.snackBarText = "Data Saved Successfully";
      this.snackBarModel = true;
      setTimeout(this.closeDialogItem, 2000);
    },
    closeDialogItem() {
      this.dialogItem = false;
      this.getSelectedTableRows();
    },
    getSelectedTableItems(selectedTableItems) {
      this.selectedTableItems = selectedTableItems;
    },
    selectAllTableItems() {
      if (this.selectedTableItemsAll) {
        this.selectedTableItems = [];
        this.tableRows.forEach((item) => {
          this.selectedTableItems.push(item.id);
        });
      } else {
        this.selectedTableItems = [];
      }
    },
    bulkDelete() {
      this.$store.commit("setGlobalConfirmDelete", true);
    },
    takeActionAfterDeleteConfirmChoice(choice) {
      if (choice) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/bulk-delete",
            { table: this.selectedTable, rowIds: this.selectedTableItems },
            this.getAccessToken
          )
          .then((response) => {
            this.$store.commit("setLoader", false);
            if (response.includes("success")) {
              this.selectedTableItems = [];
              this.getSelectedTableRows();
            }
          });
      } else {
        this.$store.commit("setGlobalConfirmDelete", false);
      }
    },
  },
};
</script>

<style></style>
